import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-[#0a0a0a] text-[#6b6b6b] py-8 md:py-10 border-t border-white/5" data-id="element-43">
      <div className="container mx-auto px-5 md:px-6" data-id="element-44">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-45">
          {/* Brand */}
          <div className="flex items-baseline gap-1.5" data-id="element-46">
            <span className="font-black text-white uppercase tracking-tight text-base" data-id="element-47">
              MITCHELL
            </span>
            <span className="text-[#d4a853] font-light uppercase tracking-wide text-sm" data-id="element-48">
              The Kia Boss
            </span>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 text-xs" data-id="element-49">
            <span className="flex items-center gap-1.5" data-id="element-50">
              <MapPin className="w-3 h-3 text-[#d4a853]" data-id="element-51" />
              {t('footer.address')}
            </span>
            <span className="flex items-center gap-1.5" data-id="element-52">
              <Clock className="w-3 h-3 text-[#d4a853]" data-id="element-53" />
              {t('footer.hours')}
            </span>
          </div>

          {/* Legal */}
          <div className="text-center md:text-right text-[11px]" data-id="element-54">
            <p data-id="element-55">
              &copy; {new Date().getFullYear()} Mitchellthekiaboss.{' '}
              {t('footer.rights')}
            </p>
            <p className="mt-0.5 text-[#444444]" data-id="element-56">{t('footer.serving')}</p>
          </div>
        </div>
      </div>
    </footer>;
}